import 'amazon-connect-streams';
import 'amazon-connect-chatjs';
import { useEffect, useRef } from 'react';
import { IntegrationChannel, ThirdPartyWSMethod } from '../../CassieContainer/websocket/types';
import { CassieWebsocketInvokeMethod } from '../../CassieContainer/websocket/CassieWebsocketContext';
import { getChatSession } from '../../../utils/getChatSession';
import { ParticipantRole } from '../../../utils/participantRole';

interface UseChatNotificationHandlerProps {
  isNotifyChatMessageEnabled: boolean | undefined;
  invoke: CassieWebsocketInvokeMethod;
}

export function useChatNotificationHandler({
  isNotifyChatMessageEnabled,
  invoke
}: UseChatNotificationHandlerProps): void {
  const invokeRef = useRef(invoke);
  const hasRegisteredMessageHandlerRef = useRef(false);

  useEffect(() => {
    invokeRef.current = invoke;
  }, [invoke]);

  useEffect(() => {
    if (!isNotifyChatMessageEnabled || hasRegisteredMessageHandlerRef.current) return;

    connect.contact(contact => {
      if (contact.getType() !== connect.ContactType.CHAT) {
        return;
      }

      contact.onConnected(async () => {
        const chatSession = await getChatSession(contact);
        if (!chatSession) return;

        if (hasRegisteredMessageHandlerRef.current) return;
        hasRegisteredMessageHandlerRef.current = true;

        chatSession.onMessage(async (event: connect.ChatMessageEvent) => {
          const message = event.data as connect.ChatTranscriptItem;

          if (message.ParticipantRole !== ParticipantRole.CUSTOMER) {
            return;
          }

          const payload = {
            channelConversationId: contact.contactId,
            channel: IntegrationChannel.CATO,
            message: message?.Content ?? '',
            participantRole: message.ParticipantRole as ParticipantRole
          };

          void invokeRef.current(ThirdPartyWSMethod.NOTIFY_CHAT_MESSAGE, payload);
        });
      });
    });
  }, [isNotifyChatMessageEnabled]);
}
